import clsx from "clsx";
import { MouseEventHandler } from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

interface PaginationProps {
  totalPages: number;
  page: number;
  onChange?: (page: number) => void;
}

export default function Pagination(props: PaginationProps) {
  const { page: activePage, totalPages } = props;
 

  if (totalPages <= 1) return null;
  const navBtnClasses =
    "hover:bg-primary hover:text-white border bg-white text-primary-text border-primary-text w-[34px] h-[34px]  items-center justify-center rounded-[6px] text-3xl inline-block";
  const generatePages = () => {
    const pagesArray: string[] = [];
    // if (totalPages > 5 && activePage > 3) {
    //   const left = 6 - (6 - activePage) - 1;
    //   const start = activePage - left;

    //   for (let i = start; i <= start + 5; i++) {
    //     if (i <= totalPages) {
    //       pagesArray.push(`${i}`);
    //     }
    //   }
    // } else {
    // }
    
    for (let i = 1; i <= totalPages; i++) {
      pagesArray.push(`${i}`);
    }

    return pagesArray;
  };
  const pages = generatePages();

  const handleChangePage = (newPage: number) => {
    if (props.onChange) {
      props.onChange(newPage); 
      
      var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?page=' + newPage ;

      window.history.pushState({ path: refresh }, '', refresh);
    }
  };

  return ( 
      <div className="p-4 gap-2 text-right bg-white rounded-lg w-full overflow-auto whitespace-nowrap align-top">
        <button
          className={navBtnClasses}
          onClick={() => handleChangePage(activePage - 1)}
          disabled={activePage === 1}>
          <MdChevronLeft />
        </button>
        {pages.map((p) => {
          if (p === "...") {
            return <div>...</div>;
          }
          return (
            <PagitionButton
              key={`paginate-item-${p}`}
              page={+p}
              activePage={activePage}
              onClick={() => handleChangePage(+p)}
            />
          );
        })}

        <button
          className={navBtnClasses + ' ml-2'}
          onClick={() => handleChangePage(activePage + 1)}
          disabled={activePage === totalPages}>
          <MdChevronRight />
        </button>
      </div> 
  );
}

interface PagitionButtonProps {
  page: number;
  activePage: number;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

function PagitionButton(props: PagitionButtonProps) {
  const isActive = props.activePage === props.page;
  const classes = clsx([
    "w-[34px] h-[34px] inline-block align-top ml-2 items-center justify-center rounded-[6px] border hover:bg-primary hover:text-white ",
    isActive
      ? "bg-primary text-white border-primary"
      : "bg-white text-primary-text border-primary-text"
  ]);
  return (
    <button className={classes} onClick={props.onClick}>
      {props.page}
    </button>
  );
}
